import React from "react";
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper.tsx";
import { GridLegacy, Typography } from "@mui/material";
import { useWatch } from "react-hook-form";

function Counters() {
  const usedCounter = useWatch({ name: "usedCounter" });
  const discountedItemsCounter = useWatch({ name: "discountedItemsCounter" });
  const usedLastdate = useWatch({ name: "usedLastdate" });
  const usedDayCounter = useWatch({ name: "usedDayCounter" });
  const discountedItemsDayCounter = useWatch({ name: "discountedItemsDayCounter" });
  return (
    <div style={{ width: "100%", height: "100%" }}>
      <Card>
        <CardBody style={{ padding: 16 }}>
          <GridLegacy container spacing={1}>
            <GridLegacy item xs={12}>
              <Typography variant={"h5"}>
                <TranslationWrapper tDefault={"Global counters"} tKey={"voucherDefs.form.counters.headerText"} />
              </Typography>
            </GridLegacy>
            <GridLegacy item xs={12}>
              <Typography>
                <TranslationWrapper
                  tDefault={
                    "PLease note: These counters are Global counters. They show the combined totals of all vouchers belonging to this definition."
                  }
                  tKey={"voucherDefs.form.counters.explanation"}
                />
              </Typography>
            </GridLegacy>
            <GridLegacy item xs={12}>
              <h5>
                <b>Used (total-counter)</b>
                <br />
                {usedCounter ? usedCounter.toString() : "--"}
              </h5>
            </GridLegacy>
            <h5>
              <b>Number of discounted items (total-counter)</b>
              <br />
              {discountedItemsCounter ? discountedItemsCounter.toString() : "--"}
            </h5>
            <hr />
            <h5>
              <b>Last date used: </b>
              <br />
              {usedLastdate ? usedLastdate.toString() : "--"}
            </h5>
            <h5>
              <b>Used on last date (day-counter)</b>
              <br />
              {usedDayCounter ? usedDayCounter.toString() : "--"}
            </h5>
            <h5>
              <b>Number of discounted items on last date (day-counter)</b>
              <br />
              {discountedItemsDayCounter ? discountedItemsDayCounter.toString() : "--"}
            </h5>
          </GridLegacy>
        </CardBody>
      </Card>
    </div>
  );
}

export default Counters;
